import { ofType } from 'redux-observable'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import {
  actionTypes,
  loadApprovalBadgeFailure,
  loadApprovalBadgeSuccess,
  loadNotifyFailure,
  loadNotifySuccess,
  loadTaskBadgeFailure,
  loadTaskBadgeSuccess,
} from './actions'
import { getApprovalBadge, getNotifications, getTaskBadge } from './services'
import {
  actionTypes as globalActionTypes,
  loadConfigurationsActionFailure,
  loadConfigurationsActionSuccess,
} from '../../../store/global/actions'
import { getConfigurationsService } from '../../../store/global/services'

const fetchGetTaskBadgeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOAD_TASK_BADGE),
    mergeMap(() =>
      getTaskBadge().pipe(
        map((response: any) => loadTaskBadgeSuccess(response)),
        catchError((error: any) => of(loadTaskBadgeFailure(error)))
      )
    )
  )

const fetchGetApprovalBadgeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOAD_APPROVAL_BADGE),
    mergeMap(() =>
      getApprovalBadge().pipe(
        map((response: any) => loadApprovalBadgeSuccess(response)),
        catchError((error: any) => of(loadApprovalBadgeFailure(error)))
      )
    )
  )

const fetchGetNotifyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOAD_NOTIFY),
    mergeMap(() =>
      getNotifications().pipe(
        map((response: any) => loadNotifySuccess(response)),
        catchError((error: any) => of(loadNotifyFailure(error)))
      )
    )
  )

const fetchGlobalConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(globalActionTypes.LOAD_CONFIGURATIONS),
    mergeMap(() =>
      getConfigurationsService().pipe(
        map((response: any) => loadConfigurationsActionSuccess(response)),
        catchError((error: any) => of(loadConfigurationsActionFailure(error)))
      )
    )
  )

const epics = [
  fetchGetTaskBadgeEpic,
  fetchGetApprovalBadgeEpic,
  fetchGetNotifyEpic,
  fetchGlobalConfigurationsEpic,
]

export default epics
